export default __webpack_public_path__ + "static/media/nft13.15035d6e.png";